<template>
  <ra-card v-loading="loading">
    <template slot="header">
      <p>Total Requests</p>
      <div class="is-flex is-align-center">
        <el-dropdown @command="setRange" class="mr-1">
          <el-button type="plain" size="small">
            {{ rangeTypes[range] }} <i class="ra-icon--chevron-down" />
          </el-button>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item
              v-for="(value, key, i) in rangeTypes"
              :key="i"
              :class="{ selected: key === range }"
              :command="key"
              >{{ value }}</el-dropdown-item
            >
          </el-dropdown-menu>
        </el-dropdown>
        <ra-periods @set-period="setPeriod" />
      </div>
    </template>
    <template slot="content">
      <line-chart
        v-if="dataAvailable"
        :data="requestChart.data"
        :labels="requestChart.labels"
        :height="400"
      />
      <ra-empty-state v-else :type="'line-chart'" />
    </template>
  </ra-card>
</template>

<script>
import LineChart from "@/components/Chart/LineChart";
import apiConstants from "@/apiConstants.js";

export default {
  name: "VerificationsChart",
  components: {
    LineChart
  },
  data() {
    return {
      loading: false,
      range: "date",
      rangeTypes: {
        date: "Date",
        month: "Month",
        year: "Year"
      },
      period: {
        start_at: "",
        end_at: ""
      },
      labels: [],
      data: [],
      slotTypes: apiConstants.SLOT_TYPES,
      groupBy: apiConstants.SLOT_TYPES[0].value,
      startDate: "",
      endDate: "",
      noAccessCodes: apiConstants.NO_ACCESS_CODES
    };
  },

  computed: {
    requestChart() {
      const labels = this.labels;
      const data = this.data;
      return { data, labels };
    },

    dataAvailable() {
      return this.labels.length && this.data.length;
    }
  },

  watch: {
    range() {
      this.getVerificationsLogs();
    }
  },

  methods: {
    setRange(group) {
      this.range = group;
    },

    setPeriod(period) {
      const { start_at, end_at } = period;
      this.period.start_at = start_at;
      this.period.end_at = end_at;

      this.getVerificationsLogs();
    },

    getVerificationsLogs() {
      this.loading = true;
      const { start_at, end_at } = this.period;
      const apiUrl = "services/logs";
      const groupBy = JSON.stringify([
        {
          field: "created_at",
          alias: this.range,
          func: this.range
        }
      ]);
      const aggs = JSON.stringify([
        {
          field: "id",
          func: "count",
          alias: "total_count"
        }
      ]);

      let params = `aggs=${aggs}&group_by=${groupBy}`;
      let filters = [];

      filters.push({
        field: "created_at",
        value: start_at,
        cond_op: ">="
      });

      filters.push({
        field: "created_at",
        value: end_at,
        cond_op: "<="
      });

      params += `&filters=${JSON.stringify(filters)}`;

      this.$http
        .post(
          apiUrl,
          {
            method: "GET",
            params: params
          },
          {
            headers: {
              "data-baseurl-namespace": apiConstants.URLS.SERVICES
            }
          }
        )
        .then(response => {
          const resData = response.data;
          if (resData.status === "error") {
            this.handleErrors(resData);
            this.loading = false;
          } else {
            const list = resData.list;
            if (list.length) {
              this.labels = list.map(ls =>
                this.mFormatShortDate(ls[`${this.range}`], "m-d")
              );
              this.data = list.map(ls => ls.total_count);
            }
            this.loading = false;
          }
        })
        .catch(() => {
          this.notification("Error", "An unknown error occurred", "danger");
          this.loading = false;
        });
    },
  }
};
</script>

<style></style>
